// directives/lazy-render.js
export default {
  inserted(el, binding) {
    const callback = binding.value;

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          callback(); // Trigger load
          observer.unobserve(el); // Stop observing
        }
      });
    }, {
      rootMargin: '100px',
      threshold: 0.1
    });

    observer.observe(el);
  }
};



// WEBPACK FOOTER //
// ./src/utils/directives/lazy-load.js